import Home from '@/components/page/Home/Home';
import Account from '@/components/page/Account/Account';
import Site from '@/components/page/Site';
import AdvancedMotorForm from '@/components/page/Home/motors/AdvancedMotorForm.vue';
import SimulationDetails from '@/components/page/Home/motors/simulations/details.vue';

export default [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/site/:siteUid?',
        name: 'Site',
        component: Site
    },
    {
        path: '/account',
        name: 'Account',
        component: Account
    },
    {
        path: '/advanced-motor-form/:motorUid?',
        name: 'AdvancedMotorForm',
        component: AdvancedMotorForm
    },
    {
        path: '/simulation-details/:motorUid?/:mode?',
        name: 'SimulationDetails',
        component: SimulationDetails
    },


];



// WEBPACK FOOTER //
// ./src/router/routes.js